import React from 'react';
import LaboratoryResearchesTable from './Components/LaboratoryResearchesTable';

const LaboratoryResearchesPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <LaboratoryResearchesTable />
      </div>
    </div>
  );
};

export default LaboratoryResearchesPage;
